import React from 'react';
import QuoteCreator from '../../../components/QuoteCreator';
import { NicheKey } from '../types';
import { UserProfile, FinancialConfig, Quote } from '../../../types';

export interface SavedQuoteData {
  id: string;
  title: string;
  clientName: string;
  totalPrice: number;
  nicheKey: NicheKey;
  items?: any[];
}

export interface QuoteBuilderModalProps {
  vhbRate: number;
  defaultNiche?: NicheKey;
  onSaveQuote: (quoteData: SavedQuoteData) => Promise<void> | void;
  onBack: () => void;
}

/**
 * Wrapper de Demonstração / Lab-ERP para Gravação de Tutoriais.
 * Consome diretamente o componente canônico QuoteCreator garantindo sincronia
 * e utiliza React.ComponentProps para quebrar o build se as props reais mudarem.
 */
export default function QuoteBuilderModal({
  vhbRate,
  defaultNiche = 'geral',
  onSaveQuote,
  onBack
}: QuoteBuilderModalProps) {
  // Trava de tipagem estrita com as Props reais do QuoteCreator de produção
  type EnforcedQuoteCreatorProps = React.ComponentProps<typeof QuoteCreator>;

  const mockUser: UserProfile = {
    id: 'demo-user-playground',
    ownerName: 'Usuário Demonstração',
    businessName: 'Oficina & Serviços Modelo',
    email: 'demo@resolvmax.com.br',
    niche: defaultNiche,
    plan: 'Empresa',
    isTrialActive: true,
    maxFreeQuotes: 99999,
  };

  const mockConfig: FinancialConfig = {
    userId: 'demo-user-playground',
    monthlyFixedCost: 3500,
    proLaboreGoal: 5000,
    weeklyWorkHours: 40,
    baseHourValue: vhbRate || 65,
    paymentFeePercentage: 3.5,
    defaultCommissionPercentage: 0,
  };

  const handleSaveQuote = (quote: Quote) => {
    if (onSaveQuote) {
      onSaveQuote({
        id: quote.id,
        title: quote.serviceName || 'Orçamento Demo',
        clientName: quote.clientName || 'Cliente Modelo',
        totalPrice: quote.finalPrice || 0,
        nicheKey: defaultNiche,
        items: [...(quote.products || []), ...(quote.services || [])],
      });
    }
    onBack();
  };

  const realProps: EnforcedQuoteCreatorProps = {
    user: mockUser,
    config: mockConfig,
    materials: [],
    recipes: [],
    services: [],
    onClose: onBack,
    onSaveQuote: handleSaveQuote,
    quotesCount: 1,
    plan: 'Empresa',
  };

  return (
    <div className="fixed inset-0 z-50 bg-slate-900/80 backdrop-blur-sm overflow-y-auto">
      <QuoteCreator {...realProps} />
    </div>
  );
}
